export const SaveMSTAsset = async (dataJson: any) => {
  const respone = await fetch("api/Asset/SaveMstAsset", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      mstAssets: Array.isArray(dataJson) ? dataJson : [dataJson],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  return respone;
};
